import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined'
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  checked: boolean

  onChange(checked: boolean): void
}

const SaveAsDefaultKitToggle: React.FC<Props> = ({ checked, onChange }) => {
  const { t } = useTranslation()
  const Icon = checked ? ToggleOnOutlinedIcon : ToggleOffOutlinedIcon
  return (
    <div className='flex items-start gap-10'>
      <span
        className='flex-shrink-0 flex cursor-pointer'
        role='switch'
        aria-checked={checked}
        onClick={() => onChange(!checked)}
      >
        <Icon className={checked ? 'text-secondary' : 'text-gray'} sx={{ fontSize: '40px' }} />
      </span>
      <div>
        <div className='font-bold text-lg mb-5'>
          {t('title.saveAsDefaultKitConfiguration', 'Save as Default Kit Configuration')}
        </div>
        <div className='text-base'>
          {t('description.saveAsDefaultKitConfiguration', 'Apply this configuration by default for future orders.')}
        </div>
      </div>
    </div>
  )
}

export default SaveAsDefaultKitToggle
